import { useState } from 'react'

import MarketTradeBuy from './MarketTradeBuy'
import MarketTradeSell from './MarketTradeSell'

import { marketTradeTabs } from '../../../../constants'

const MarketTrade = () => {
  const [activeTab, setActiveTab] = useState(marketTradeTabs[0])

  const marketTradeTabsContent = marketTradeTabs.map((marketTradeTab) => {
    const isActive = activeTab === marketTradeTab

    return (
      <button
        key={marketTradeTab}
        className={`text-sm font-normal ${isActive ? 'text-[#007bff]' : 'text-[#4a4a4a]'}`}
        onClick={() => setActiveTab(marketTradeTab)}
      >
        {marketTradeTab}
      </button>
    )
  })

  return (
    <div className="w-full rounded-[2px] border-[#e0e3eb] border-[1px] p-[14px] bg-white">
      <div className="flex items-center w-full mb-[15px] gap-x-[32px] px-[2px]">
        {marketTradeTabsContent}
      </div>

      <div className="w-full flex items-stretch">
        <MarketTradeBuy />

        <MarketTradeSell />
      </div>
    </div>
  )
}

export default MarketTrade
